import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { lastValueFrom } from 'rxjs';
import { MBrandListModal } from 'src/app/pages/product/product.module';
import { WsLandingService } from 'src/app/ws/wsLanding/ws-landing.service';

@Component({
  selector: 'app-responsive-searchbar-black-border',
  templateUrl: './responsive-searchbar-black-border.component.html',
  styleUrls: ['./responsive-searchbar-black-border.component.scss']
})
export class ResponsiveSearchbarBlackBorderComponent {
  show: boolean = false;
  text: any = ''
  customerData: any;
  productList: any = [];
  brandList: any = [];
  categoryList: any = [];
  skinTypeList: any = [];
  skinConcernsList: any = [];
  constructor(private wsLandingService: WsLandingService, private router: Router) {

  }

  async getCustomer(val: any, mouse?: any) {
    if (this.text.length > 0) {
      this.show = true
      this.getCustomerData(this.text)
    } else if (this.text.length > 0 && mouse) {
      this.show = true
      this.getCustomerData(this.text)
    } else if (this.text.length == 0) {
      this.show = false
    } else {
      this.show = false
    }
  }

  async getCustomerData(val: any) {
    const getCustomer = this.wsLandingService.getCustomerProducts(val)
    await lastValueFrom(getCustomer).then(async response => {
      if (response && response.statusCode == 200) {
        this.customerData = response.data;
        this.productList = this.customerData.productList;
        this.brandList = this.customerData.brandList;
        this.categoryList = this.customerData.categoryList;
        this.skinConcernsList = this.customerData.skinConcernsList;
        this.skinTypeList = this.customerData.skinTypeList;
      } else {
      }
    })
  }

  closeSearchBar() {
    this.show = false
    this.text = ''
  }

  showProduct(product: any) {
    this.router.routeReuseStrategy.shouldReuseRoute = function () {
      return false;
    }
    this.router.onSameUrlNavigation = 'reload';
    var productName = product.name.split(' ').join('_').replace(',', '')
    this.router.navigate(["/product-detail-updated/" + product.id + '/' + productName.replace(/[&\/\#,+()$~%.'":*?<>{}]/g,'_')])
  }


  viewBrandDetail(brand: MBrandListModal) {
    this.router.routeReuseStrategy.shouldReuseRoute = function () {
      return false;
    }
    this.router.onSameUrlNavigation = 'reload';
    var brandId = brand.id;
    this.router.navigate(["/individual-brand/" + brand.name.replace(/[&\/\#,+()$~%.'":*?<>{}]/g,'_')], { 
      queryParams: { 
        b: brandId
      }
  })
  }

  goToShopAll(val: any, catId: any, subId?: any) {
    this.router.routeReuseStrategy.shouldReuseRoute = function () {
      return false;
    }
    this.router.onSameUrlNavigation = 'reload';
    this.router.navigate(["/shop-all/" + val], { 
      queryParams: { 
        c: catId,
        sub: subId
      }
  })
  }


  goToShopAllWithSkinConcern(val: any, catId: any, skinConcernId?: any) {
    this.router.routeReuseStrategy.shouldReuseRoute = function () {
      return false;
    }
    this.router.onSameUrlNavigation = 'reload';
    this.router.navigate(["/shop-all"], { 
      queryParams: { 
        sc: skinConcernId
      }
  })
  }

  goToShopAllWithSkinType(val: any, catId: any, skinTypeId?: any) {
    this.router.routeReuseStrategy.shouldReuseRoute = function () {
      return false;
    }
    this.router.onSameUrlNavigation = 'reload';
    this.router.navigate(["/shop-all"], { 
      queryParams: { 
        st: skinTypeId
      }
  })
  }
}